import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

import Dashboard from '@/views/Dashboard.vue';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';

//Fantasy
import FantasyHome from '@/views/fantasy/Fantasy';
import FantasyContests from '@/views/fantasy/Contests/index';
import FantasyContestsView from '@/views/fantasy/Contests/view';
import FantasyContestsEdit from '@/views/fantasy/Contests/edit';
import FantasyCompetitions from '@/views/fantasy/Competitions/index';
import FantasyPlayers from '@/views/fantasy/Players/index';
import FantasyTeams from '@/views/fantasy/Teams/index';
import FantasyMatches from '@/views/fantasy/Matches/index';
import FantasyMatchsets from '@/views/fantasy/Matchsets/index';
import FantasyCategories from '@/views/fantasy/Categories/index';
import FantasyNetworks from '@/views/fantasy/Networks/index';

//Casino
import RoundsHome from '@/views/casino/Rounds/index';
import RTPHome from '@/views/casino/Rtp/index';
import LobbyHome from '@/views/casino/Lobby/index';

//Campaigns
import FreeroundsHome from '@/views/campaigns/Freerounds/index';
import FreespinsHome from '@/views/campaigns/Freespins/index';
import OptInHome from '@/views/campaigns/OptIn/index';
import ReferAFriendHome from '@/views/campaigns/ReferAFriend/index';

//Others
import GamesHome from '@/views/games/index';
import ProvidersHome from '@/views/providers/index';
import OperatorsHome from '@/views/operators/index';
import AdministratorsHome from '@/views/administrators/index';
import UsersHome from '@/views/users/index';
import UsersInfo from '@/views/users/view';
import Tournaments from '@/views/tournaments/index';
import FinancesHome from '@/views/finances/index';

//NOT FOUND
import NotFound from '@/views/NotFound';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    components: {
      login: Login
    }
  },
  {
    path: '/login',
    redirect: { name: 'Login' },
  },
  {
    path: '/home',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: '',
        components: {
          content: Home
        }
      }
    ]
  },
  {
    path: '/fantasy',
    name: 'Fantasy',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: 'home',
        name: 'FantasyHome',
        components: {
          content: FantasyHome
        }
      },
      {
        path: 'matchsets',
        components: {
          content: FantasyMatchsets
        }
      },
      {
        path: 'contests',
        components: {
          content: FantasyContests
        }
      },
      {
        path: 'contest/:contestid',
        components: {
          content: FantasyContestsView
        }
      },
      {
        path: 'contests/edit',
        components: {
          content: FantasyContestsEdit
        }
      },
      {
        path: 'competitions',
        components: {
          content: FantasyCompetitions
        }
      },
      {
        path: 'teams',
        components: {
          content: FantasyTeams
        }
      },
      {
        path: 'teams/:competitionid',
        components: {
          content: FantasyTeams
        }
      },
      {
        path: 'matches',
        components: {
          content: FantasyMatches
        }
      },
      {
        path: 'matches/:competitionid',
        components: {
          content: FantasyMatches,
        }
      },
      {
        path: 'players',
        components: {
          content: FantasyPlayers
        }
      },
      {
        path: 'networks',
        components: {
          content: FantasyNetworks
        }
      },
      {
        path: 'categories',
        components: {
          content: FantasyCategories
        }
      },

      // {
      //   path: 'players/:competition',
      //   components: {
      //     content: FantasyPlayers
      //   }
      // }
    ]
  },
  {
    path: '/casino',
    name: 'Casino',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: 'rtp',
        name: 'RTPHome',
        components: {
          content: RTPHome
        }
      },
      {
        path: 'rounds',
        name: 'RoundsHome',
        components: {
          content: RoundsHome
        }
      },
      {
        path: 'lobby',
        name: 'LobbyHome',
        components: {
          content: LobbyHome
        }
      },
      // {
      //   path: 'freerounds',
      //   name: 'FreeroundsHome',
      //   components: {
      //     content: FreeroundsHome
      //   }
      // },
    ]
  },
  {
    path: '/campaigns',
    name: 'Campañas',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: 'freespins',
        name: 'FreespinsHome',
        components: {
          content: FreespinsHome
        }
      },
      {
        path: 'freerounds',
        name: 'FreeroundsHome',
        components: {
          content: FreeroundsHome
        }
      },
      {
        path: 'optin',
        name: 'OptInHome',
        components: {
          content: OptInHome
        }
      },
      {
        path: 'referafriend',
        name: 'ReferAFriendHome',
        components: {
          content: ReferAFriendHome
        }
      },
    ]
  },
  {
    path: '/users',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: '',
        name: 'UsersHome',
        components: {
          content: UsersHome
        }
      },
      {
        path: 'view',
        name: 'UsersInfo',
        components: {
          content: UsersInfo
        }
      }
    ]
  },
  {
    path: '/games',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: '',
        name: 'GamesHome',
        components: {
          content: GamesHome
        }
      }
    ]
  },
  {
    path: '/providers',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: '',
        name: 'ProvidersHome',
        components: {
          content: ProvidersHome
        }
      }
    ]
  },
  {
    path: '/operators',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: '',
        name: 'OperatorsHome',
        components: {
          content: OperatorsHome
        }
      }
    ]
  },
  {
    path: '/finances',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: '',
        name: 'FinancesHome',
        components: {
          content: FinancesHome
        }
      }
    ]
  },
  {
    path: '/administrators',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: '',
        name: 'AdministratorsHome',
        components: {
          content: AdministratorsHome
        }
      }
    ]
  },
  {
    path: '/tournaments',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: '',
        name: 'TournamentsHome',
        components: {
          content: Tournaments
        },
        meta: { authorizedRole: ['superuser', 'accountmanager', 'finance'] }
      }
    ]
  },
  {
    path: '/404',
    components: {
      dashboard: Dashboard
    },
    children: [
      {
        path: '',
        name: 'NotFound',
        components: {
          content: NotFound
        },
      }
    ]
  }

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});


router.beforeEach((to, from, next) => {
  const publicPages = ['/', '/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = store.state.login.token;
  if (authRequired && !loggedIn) {    // necessary logged
    return next('/login');
  } else {
    if(to.meta.authorizedRole == undefined){    // public
      next();
    } else if(to.meta.authorizedRole.includes(store.state.login.role)){  // role admitted
      next();
    } else {    // no admitted, ??
      // TODO, si no está autorizado, qué hacer?
      // página no encontrada (404), página prohibida 403, página no autorizada 401

      console.log('sin permiso para la ruta: ' + to.path);
      return next('/404');
    }
  }
});

export default router;
